import React from 'react'
import { ThemeProvider } from 'system'
import { MDXProvider } from '@mdx-js/react'

import { IdentityStore } from './components/IdentityStore'
import { theme } from './theme'
import { mdxComponents } from './mdxComponents'

export const wrapPageElement = ({ element, props }) => {
  const location = props.location

  if (!location.pathname.startsWith('/reference')) return element

  return (
    <IdentityStore>
      <ThemeProvider theme={theme}>
        <MDXProvider components={mdxComponents}>{element}</MDXProvider>
      </ThemeProvider>
    </IdentityStore>
  )
}
